import { SecurityChallenge } from './security-challenge.model';

export class Credentials {
    email: string;
    password: string;
    securityChallenge: SecurityChallenge;
    question: string;
    answer: string;

    constructor(props?: any) {
        if (props) {
            this.email = props.email;
            this.password = props.password;
            this.securityChallenge = props.securityChallenge;
            this.question = props.question;
            this.answer = props.answer;
        }
    }
}
